import restAPI from './rest/rest';

export default store => next => action => {
    restAPI(store, next, action);
}